import React, { Component, memo, Suspense } from 'react';

import { notifyBugsnagError } from 'BugSnagWrapper';
import { isOptionalChunkLoadError } from 'utils/lazyOptional';

class OptionalChunkErrorBoundary extends Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error) {
        if (isOptionalChunkLoadError(error)) {
            notifyBugsnagError(error.originalError || error);
        }
    }

    render() {
        const { children } = this.props;
        const { error } = this.state;

        if (!error) return children;
        if (!isOptionalChunkLoadError(error)) throw error;

        return null;
    }
}

const OptionalLazyBoundary = memo(({ children, fallback = null }) => (
    <OptionalChunkErrorBoundary>
        <Suspense fallback={fallback}>{children}</Suspense>
    </OptionalChunkErrorBoundary>
));

OptionalLazyBoundary.displayName = 'OptionalLazyBoundary';

export default OptionalLazyBoundary;
